'use client';
const Transformer = (transforms)=>{
    const cleanTransforms = transforms.filter(Boolean);
    const transformer = {
        reduce: transforms.length ? reduce : skip
    };
    function skip(_eventName, payload) {
        return payload;
    }
    function reduce(eventName, payload) {
        return cleanTransforms.reduce((target, transform)=>transform(eventName, target), payload);
    }
    return transformer;
};

export { Transformer };
//# sourceMappingURL=Transformer.js.map
